module.exports = __webpack_public_path__ + "img/recycle-bin.3f941d0f.svg";